var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"10","height":"7","viewBox":"0 0 10 7","fill":"#05D699","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"y":"2.5","width":"6","height":"2"}}),_c('path',{attrs:{"d":"M9.5 3.5L6 0V7L9.5 3.5Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }